/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

type Props = {
  values: {
    getSourceRGB: {
      r: number[],
      b: number[],
      g: number[]
    },
    getPickerTextColor: {
      start: string,
      end: string
    },
    getScaleStep: number,
    stepValues: number[]
  },
  methods: {
    fetchColor: (event: any) => void,
    fetchStep: (event: any) => void,
    updatePickerTextColor: (event: any) => void,
    convertDECtoHEX: (decimal: number) => string,
    generate: () => void
  }
}

export const Controller = React.memo<Props>((props) => {
  return (
    <>
      <div className='p-app-controller-section'>
        <div className='__controller'>
          <span className='__input u-form-input u-form-color-picker u-form-neumorphism-deboss'>
            <label className='__label'>
              <input 
                type="color" 
                id="start" 
                onChange={(event) => { 
                  props.methods.fetchColor(event); 
                  props.methods.updatePickerTextColor(event); 
                }} 
                defaultValue={'#000000'} 
              />
              <span 
                className='__value'
                style={{
                  background: `#${props.methods.convertDECtoHEX(props.values.getSourceRGB.r[0])}${props.methods.convertDECtoHEX(props.values.getSourceRGB.g[0])}${props.methods.convertDECtoHEX(props.values.getSourceRGB.b[0])}`,
                  color: props.values.getPickerTextColor.start
                }}
              >
                {
                  `#${props.methods.convertDECtoHEX(props.values.getSourceRGB.r[0])}${props.methods.convertDECtoHEX(props.values.getSourceRGB.g[0])}${props.methods.convertDECtoHEX(props.values.getSourceRGB.b[0])}`
                }
              </span>
            </label>
          </span>
          <span className='__heading'>Start</span>
        </div>
        <div className='__controller'>
          <span className='__input u-form-input u-form-color-picker u-form-neumorphism-deboss'>
            <label className='__label'>
              <input 
                type="color" 
                id="end" 
                onChange={(event) => { 
                  props.methods.fetchColor(event); 
                  props.methods.updatePickerTextColor(event); 
                }}
                defaultValue={'#ffffff'} 
              />
              <span 
                className='__value'
                style={
                  {
                    background: `#${props.methods.convertDECtoHEX(props.values.getSourceRGB.r[1])}${props.methods.convertDECtoHEX(props.values.getSourceRGB.g[1])}${props.methods.convertDECtoHEX(props.values.getSourceRGB.b[1])}`,
                    color: props.values.getPickerTextColor.end
                  }
                }
              >
                {
                  `#${props.methods.convertDECtoHEX(props.values.getSourceRGB.r[1])}${props.methods.convertDECtoHEX(props.values.getSourceRGB.g[1])}${props.methods.convertDECtoHEX(props.values.getSourceRGB.b[1])}`
                }
              </span>
            </label>
          </span>
          <span className='__heading'>End</span>
        </div>
        <div className='__controller'>
          <span className='__input u-form-input u-form-select u-form-neumorphism-deboss'>
            <label className='__label'>
              <select onChange={props.methods.fetchStep} defaultValue={props.values.getScaleStep}>
                {
                  props.values.stepValues.map((value) => {
                    return (
                      <option value={value} key={value}>{value}</option>
                    )
                  })
                }
              </select>
            </label>
          </span>
          <span className='__heading'>Step</span>
        </div>
      </div>
      <div className='p-app-submit-section'>
        <button onClick={props.methods.generate} type="button" className='u-form-button u-form-neumorphism-emboss'>
          <span className='__text'>generate!</span>
        </button>
      </div>
    </>
  )
});